import { ContactUsMessageDetails } from "src/app/core/data/model/contact-us-message-details-model";
import { ContactUsMessageSendReplyForm } from "src/app/core/interface";
import { BlocEvent } from "src/app/shared/bloc/base-bloc";
import { PopupCallerCallBack } from "src/app/shared/common";

export abstract class ContactUsPopupEvent extends BlocEvent{}
export class ContactUsPopUpInitEvent extends ContactUsPopupEvent {
  constructor(public caller :PopupCallerCallBack<ContactUsMessageDetails[]> ){
    super()
  }
}

export class ContactUsPopUpSendReplyEvent extends ContactUsPopupEvent {
  constructor(public replyForm : ContactUsMessageSendReplyForm ){
    super()
  }
}


